export default __webpack_public_path__ + "static/media/menu_exchange.66f8b4b2.svg";